export default __webpack_public_path__ + "static/media/step-3-of-4.2f8cc776.gif";